// extracted by mini-css-extract-plugin
export var drawerPaper = "_1m-0";
export var itemCard = "_1m-1";
export var itemImage = "_1m-2";